import { render, staticRenderFns } from "./DHLResult.vue?vue&type=template&id=b0f65c2a&scoped=true"
import script from "./DHLResult.vue?vue&type=script&lang=js"
export * from "./DHLResult.vue?vue&type=script&lang=js"
import style0 from "./DHLResult.vue?vue&type=style&index=0&id=b0f65c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f65c2a",
  null
  
)

export default component.exports